import { Box } from '@mui/material';
import { useEffect, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { useGetUserMeQuery } from '../../../services/entities/impl/blfApi/endpoints/users';
import { UserRolesEnum } from '../../../services/entities/impl/blfApi/schemas/user';
import { hasAuthorizedRole } from '../../commonUtils';
import {
  OnboardFormStepEnum,
  OnboardingTabsEnum,
  selectCurrOnboardingTab,
  setOnboardFormStep,
} from '../onboardingSlice';
import { BlockForm } from './BlockForm';
import { CustomerForm } from './CustomerForm';
import { RanchForm } from './RanchForm';
import { UserForm } from './UserForm';
import OnboardFormStepButtons from './components/OnboardFormStepButtons';

const entityFormMapper = {
  [OnboardingTabsEnum.customers]: <CustomerForm />,
  [OnboardingTabsEnum.ranches]: <RanchForm />,
  [OnboardingTabsEnum.blocks]: <BlockForm />,
  [OnboardingTabsEnum.users]: <UserForm />,
};

const OnboardForms: React.FC = () => {
  const dispatch = useAppDispatch();
  const currTab = useAppSelector(selectCurrOnboardingTab);
  const { data: user } = useGetUserMeQuery();
  const isAuthorized = hasAuthorizedRole([UserRolesEnum.root], user);

  // If the user is not authorized for edit access, set the form to view only mode
  useEffect(() => {
    if (!isAuthorized) {
      dispatch(setOnboardFormStep(OnboardFormStepEnum.View));
    }
  }, [dispatch, isAuthorized]);

  // Render the correct form based on the current tab
  const formContent = useMemo(() => {
    return entityFormMapper[currTab];
  }, [currTab]);

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: '90%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        p: '1rem',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          height: '100%',
          width: '100% ',
          maxWidth: '50rem',
          display: 'grid',
          gridTemplateColumns: '1fr',
          gridTemplateRows: 'min-content 1fr',
          gap: '1rem',
        }}
      >
        <OnboardFormStepButtons />
        <Box
          sx={{
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'auto',
          }}
        >
          {formContent}
        </Box>
      </Box>
    </Box>
  );
};

export default OnboardForms;
